import type { RecordOf } from 'immutable';
import { Record } from 'immutable';

import type { QcsSyncResourceStore } from '../core/resourceStoreTypes';

// --- Alert Rule & Prefs Props
export type AlertPrefsProps = {
  isEnabled?: boolean;
  isEmailOk?: boolean;
  isEmailSupported?: Readonly<boolean>;
  isPushOk?: boolean;
  isPushSupported?: Readonly<boolean>;
  isSmsOk?: false; // Sms is unused for now
  isSmsSupported?: Readonly<boolean>;
  isInProductOk?: Readonly<boolean>;
  isInProductSupported?: boolean;
};

export type AlertRuleProps = {
  id: string;
  preferences: AlertPrefsProps;
  title: string;
  description: string;
  product?: string;
  group?: string;
  type?: string;
  inputVariables?: any;
  inputValues?: any;
  isHidden?: boolean;
};

// -- Record Generators --
export const mkAlertPrefs = Record<AlertPrefsProps>({
  isEnabled: undefined,
  isSmsOk: undefined,
  isSmsSupported: undefined,
  isEmailOk: undefined,
  isEmailSupported: undefined,
  isPushOk: undefined,
  isPushSupported: undefined,
  isInProductOk: undefined,
  isInProductSupported: undefined,
});

export type AlertRule = RecordOf<AlertRuleProps>;

const alertRuleDefaults = {
  id: undefined,
  product: undefined,
  group: undefined,
  type: undefined,
  title: undefined,
  description: undefined,
  inputVariables: undefined,
  inputValues: undefined,
  preferences: undefined,
  isHidden: undefined,
};

export const mkAlertRule = (jsObj: AlertRuleProps): AlertRule =>
  Record<AlertRuleProps>({
    ...alertRuleDefaults,
    ...jsObj,
    preferences: jsObj.preferences && mkAlertPrefs(jsObj.preferences),
  })();

// -- Use this to make put requests to alert rule api --
type AlertRuleUpdateProps = Partial<Omit<AlertRuleProps, 'id'>> & Pick<AlertRuleProps, 'id'>;
export type AlertRuleUpdate = RecordOf<AlertRuleUpdateProps>;

export const mkAlertRuleUpdate = (jsObj: AlertRuleUpdateProps): AlertRuleUpdate =>
  Record<AlertRuleUpdateProps>({
    ...alertRuleDefaults,
    ...jsObj,
    preferences: jsObj.preferences && mkAlertPrefs(jsObj.preferences),
  })();

// -- Extend store --
export const REDUCER_KEY = 'alertRulesStore';
declare module 'app-components/utils/redux-store/rootState' {
  export default interface RootState {
    [REDUCER_KEY]: QcsSyncResourceStore<AlertRuleProps>;
  }
}
